import {
	IdentityDocumentTypeEnum,
	StaffStatusEnum,
	staffStatusToColor,
	StaffTypeEnum,
} from '@splitsecondconnect/ultramarine-shared';
import { SelectItem } from 'app/shared/models/select-item.type';

export const STAFF_STATUSES: SelectItem<StaffStatusEnum>[] = [
	{
		value: StaffStatusEnum.ACTIVE,
		displayValue: 'staff|status|active',
		pillColor: staffStatusToColor(StaffStatusEnum.ACTIVE),
	},
	{
		value: StaffStatusEnum.INACTIVE,
		displayValue: 'staff|status|inactive',
		pillColor: staffStatusToColor(StaffStatusEnum.INACTIVE),
	},
];

export const STAFF_TYPES: SelectItem<StaffTypeEnum>[] = [
	{
		value: StaffTypeEnum.GENERAL_MANAGER,
		displayValue: 'staff|type|general-manager',
	},
	{
		value: StaffTypeEnum.OPERATIONS_MANAGER,
		displayValue: 'staff|type|operations-manager',
	},
	{
		value: StaffTypeEnum.BRANCH_MANAGER,
		displayValue: 'staff|type|branch-manager',
	},
	{
		value: StaffTypeEnum.RENTAL_ADMINISTRATOR,
		displayValue: 'staff|type|rental-administrator',
	},
	{
		value: StaffTypeEnum.RENTAL_REPRESENTATIVE,
		displayValue: 'staff|type|rental-representative',
	},
	{
		value: StaffTypeEnum.LEASING_ADMINISTRATOR,
		displayValue: 'staff|type|leasing-administrator',
	},
	{
		value: StaffTypeEnum.LEASING_REPRESENTATIVE,
		displayValue: 'staff|type|leasing-representative',
	},
	{
		value: StaffTypeEnum.CLAIMS_ADMINISTRATOR,
		displayValue: 'staff|type|claims-administrator',
	},
	{
		value: StaffTypeEnum.CLAIMS_REPRESENTATIVE,
		displayValue: 'staff|type|claims-representative',
	},
	{
		value: StaffTypeEnum.FINANCIAL_CONTROLLER,
		displayValue: 'staff|type|financial-controller',
	},
	{
		value: StaffTypeEnum.ACCOUNTANT,
		displayValue: 'staff|type|accountant',
	},
	{
		value: StaffTypeEnum.MAINTENANCE_TECHNICIAN,
		displayValue: 'staff|type|maintenance-technician',
	},
	{
		value: StaffTypeEnum.DRIVER,
		displayValue: 'staff|type|driver',
	},
];

export const IDENTITY_DOCUMENT_TYPES = [
	{
		value: IdentityDocumentTypeEnum.ID_CARD,
		displayValue: 'staff|identity-document-type|id-card',
	},
	{
		value: IdentityDocumentTypeEnum.PASSPORT,
		displayValue: 'staff|identity-document-type|passport',
	},
	{
		value: IdentityDocumentTypeEnum.RESIDENCE_PERMIT,
		displayValue: 'staff|identity-document-type|residence-permit',
	},
	{
		value: IdentityDocumentTypeEnum.OTHER,
		displayValue: 'staff|identity-document-type|other',
	},
];
